import React, { useCallback, useContext } from 'react'
import { sportsHelpers } from '../cnr/reducers/reducerHelpers/sportsHelpers'
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { _matchLsTypes } from '../cnr/reducers/SportsDataReducer';
import { deleteField } from 'firebase/firestore';

export const _matchConflictTypes = {
  duplicateMatch: 'duplicateMatch',
  overlap: 'overlap',
  approved: 'approved',
  cancelled: 'cancelled',
  exhibition: 'exhibition',
  postponed: 'postponed',
  dateChanged: 'dateChanged',
  matchIsNew: 'matchIsNew',
  matchIsMissing: 'matchIsMissing',
  scoreChanged: 'scoreChanged',
  scoreIsNew: 'scoreIsNew',
  resultsChanged: 'resultsChanged',
  resultsNew: 'resultsNew',

}

const matchTargetTypes = {
  match_app: 'match_app',
  match_gs: 'match_gs',
}

export const useSportsMatches = () => {

  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { database_fns } = fns ?? {}

  const analyzeMatches = useCallback(({ matches_app = [], matches_gs = [], teams = {} }) => {
    return analyzeTheMatches({ matches_app, matches_gs: matches_gs, teams })
  }, [])

  const getMatches_dotRemoved = useCallback(({ matches_app }) => {
    const matches_nonTeam = _.filter(matches_app, match =>
      !match.home || !match.away
    );
    const updates_app_ck = _.groupBy(matches_nonTeam, '_matchCollectionKey')
    const matchesRemoved_dot = {}
    _.forEach(updates_app_ck, (ua, ck) => {
      const updates = {}
      _.forEach(ua, (uai, uamk) => {
        updates[`matches.${uai._itemKey}`] = deleteField()
      })
      matchesRemoved_dot[ck] = { ...updates }
    })
    return { matchesRemoved_dot, matches_nonTeam }
  }, [])

  const getMatches_dotUpdates = useCallback(({ updates_app }) => {
    const updates_app_ck = _.groupBy(updates_app, '_matchCollectionKey')

    const updates_app_dot = {}
    const updates_app_full = {}

    _.forEach(updates_app_ck, (ua, ck) => {
      const updates = {}
      const updatez = {}
      _.forEach(ua, (uai, uamk) => {
        updates[`matches.${uai._itemKey}`] = uai._updates_app
        updatez[uai._itemKey] = uai
      })
      updates_app_dot[ck] = { ...updates }
      updates_app_full[ck] = { ...updatez }
    })

    const updates_grouped = _.reduce(updates_app, (groups, match) => {
      _.forEach(match._matchUpdateTypes || [], type => {
        groups[type] = groups[type] || []
        groups[type].push(match)
      })
      return groups
    }, {})

    return { updates_app_dot, updates_app_full, updates_grouped }
  }, [])

  const getMatches_flat = useCallback(({ matches_info }) => {
    return getFlatMatches(matches_info)
  }, [])

  const getMatches_grouped = useCallback(({ updates_matches }) => {
    return _.reduce(
      updates_matches,
      (result, updateData, updateKey) => {
        const _matchCollectionKey = updateData?._matchCollectionKey
        if (!_matchCollectionKey) { return result }
        if (!result[_matchCollectionKey]) { result[_matchCollectionKey] = {} }
        result[_matchCollectionKey][updateKey] = updateData?.value
        return result
      }, {}
    )
  }, [])

  const getMatches_reAssignedTeams = useCallback(({ matches_season }) => {
    const _reAssignedTeams = {}
    _.forEach(matches_season, (match, matchKey) => {
      const { away, home, teams, id } = match ?? {}
      const { id: id_away, _itemKey: itemKey_away } = away ?? {}
      const { id: id_home, _itemKey: itemKey_home } = home ?? {}
      const key_away = id_away || itemKey_away
      const key_home = id_home || itemKey_home
      if (!_.includes(teams, key_away) || !_.includes(teams, key_home)) {
        match._teamsOld = match.teams
        match.teams = [key_away, key_home]
        _reAssignedTeams[id] = match
      }
    })
    return { _reAssignedTeams }
  }, [])

  const switchTwoTeams = useCallback(({ teams,
    matches,
    teamKey1,
    teamKey2,
    callback }) => {
    return switchTeams({
      teams,
      matches,
      teamKey1,
      teamKey2,
      callback
    })
  }, [])

  const highlightMatchesConflicts = useCallback(({ matches }) => {
    return highlightMatchesAndConflicts({ matches })
  }, [])

  const compareMatches = useCallback(({ matches_gs, matches_app, teams }) => {
    return compareTheMatches({ matches_gs, matches_app, teams, database_fns })
  }, [])

  const getMatches_badTeams = useCallback(({ matches_app }) => {
    console.log('matches_app', matches_app)
    const matches_missingTeamItemKeys = _.filter(matches_app, match =>
      !match.home?.id ||
      !match.home?._itemKey ||
      !match.away?.id ||
      !match.away?._itemKey
    )

    const matches_missingHomeAway = _.filter(matches_app, match =>
      !match.home || !match.away
    )

    const matches_missingTeams = _.filter(matches_app, match =>
      !_.isArray(match.teams) || _.size(match.teams) < 2
    )

    // console.log('matches_missingHomeAway', matches_missingHomeAway)
    // console.log('matches_missingTeams', matches_missingTeams)
    // console.log('matches_missingTeamItemKeys', matches_missingTeamItemKeys)

    const combined = _.concat(matches_missingHomeAway, matches_missingTeams, matches_missingTeamItemKeys)
    const matches_remove = buildMatchRemoves({ matches: combined })
    const matches_missingTeamItemKeys_dot = buildMatchTeamKeyUpdates({ matches: matches_missingTeamItemKeys })

    console.log('matches_remove', matches_remove)

    const matches_badTopLevels = buildMatchTopLevelDeletes({ matches: matches_missingTeamItemKeys })

    return { matches_remove, matches_missingTeamItemKeys, matches_missingTeamItemKeys_dot, matches_badTopLevels }
  }, [])

  const getMatchCounts_level = useCallback(({ matches_level }) => {
    const counts = {
      total: 0,
      completed: 0,
      missing: 0,
    }

    _.forEach(matches_level, (matches) => {
      _.forEach(matches, (match) => {
        counts.total++

        if (match?.results) {
          counts.completed++
        }

        if (match?._status?.isMissing) {
          counts.missing++
        }
      })
    })

    return counts
  }, [])

  const getMatchCounts_date = useCallback(({ matches_date }) => {
    const allMatches = _.flatMap(matches_date ?? {}, matches => matches);
    const total = _.size(allMatches);
    const completed = _.filter(allMatches, (m) => !!m?.results).length;
    const matchDay = _.filter(allMatches, (m) => !!m?._results_matchDay).length;
    const missing = _.filter(allMatches, (m) => !!m?._status?.isMissing).length;
    return { total, completed, missing, matchDay };
  }, [])

  return { getMatchCounts_level, getMatchCounts_date, getMatches_badTeams, getMatches_dotRemoved, getMatches_dotUpdates, analyzeMatches, compareMatches, highlightMatchesConflicts, getMatches_grouped, getMatches_flat, getMatches_reAssignedTeams, switchTwoTeams }
}

const getFlatMatches = (matches_info) => {

  const matches_flat = {
    actual: {
      season: sportsHelpers.getMatches_flat(matches_info.matches),
      playoffs: sportsHelpers.getMatches_flat(matches_info.matches_playoffs),
    },
    values: {
      season: null,
      playoffs: null,
    },
    filtered: {
      all: null,
      season: null,
      playoffs: null,
    },
    counts: {
      season: 0,
      playoffs: 0,
      filtered: 0,
    },
  }

  matches_flat.values.season = _.values(matches_flat.actual.season)
  matches_flat.values.playoffs = _.values(matches_flat.actual.playoffs)

  matches_flat.counts.season = matches_flat.values.season ? matches_flat.values.season.length : 0
  matches_flat.counts.playoffs = matches_flat.values.playoffs ? matches_flat.values.playoffs.length : 0

  return matches_flat
}

const switchTeams = ({
  teams,
  matches,
  teamKey1,
  teamKey2,
  callback
}) => {

  const _omitTeams = ['record', 'seed', '_matchCount', '_nextMatch', '_itemKey']
  const _omitMatches = ['record', 'seed', '_matchCount', '_nextMatch', 'position', 'sections']

  // console.log('mrs', _.filter(matches, 'results'))

  /*
   * Get the two original teams.
   * These are never modified.
   */
  const team1 = _.find(teams, {
    _itemKey: teamKey1,
  });

  const team2 = _.find(teams, {
    _itemKey: teamKey2,
  });

  if (!team1 || !team2) {
    throw new Error('Both teams must exist');
  }
  const updates_matches = {};
  const affected_matches = {};
  const updates_teams = {};

  // const team1Matches = _.pickBy(
  //   matches,
  //   match =>
  //     match?.home?._itemKey === teamKey1 ||
  //     match?.away?._itemKey === teamKey1 ||
  //     match?.home?.id === teamKey1 ||
  //     match?.away?.id === teamKey1
  // );

  /*
   * TEAM DATA
   *
   * Swap the team data while preserving
   * the destination team's _itemKey.
   */
  const team1Data = {
    ..._.omit(team1, _omitTeams),
    levels: team2?.levels,
    sections: team2?.sections,
    position: team2?.position,
  };

  const team2Data = {
    ..._.omit(team2, _omitTeams),
    levels: team1?.levels,
    sections: team1?.sections,
    position: team1?.position,
  };


  updates_teams[`teams.${teamKey1}`] = team1Data;
  updates_teams[`teams.${teamKey2}`] = team2Data;


  /*
   * MATCH DATA
   *
   * Use the same original teams, but omit
   * fields that do not belong in embedded
   * match team objects.
   */
  const team1MatchData = {
    ..._.omit(team1, _omitMatches),
  };

  const team2MatchData = {
    ..._.omit(team2, _omitMatches),
  };

  _.forEach(matches, (match, matchKey) => {

    /*
     * HOME
     */
    if (
      match?.home?._itemKey === teamKey1 ||
      match?.home?.id === teamKey1
    ) {

      updates_matches[`matches.${matchKey}.home`] = {
        ...team2MatchData,
        // Preserve the match's existing placement
        levels: match?.home?.levels,
        sections: match?.home?.sections,
        _matchCollectionKey: match?._matchCollectionKey,
      };

      affected_matches[match._itemKey] = match;

    } else if (
      match?.home?._itemKey === teamKey2 ||
      match?.home?.id === teamKey2
    ) {

      updates_matches[`matches.${matchKey}.home`] = {
        ...team1MatchData,
        levels: match?.home?.levels,
        sections: match?.home?.sections,
        _matchCollectionKey: match?._matchCollectionKey
      };

      affected_matches[match._itemKey] = match;
    }


    /*
     * AWAY
     */
    if (
      match?.away?._itemKey === teamKey1 ||
      match?.away?.id === teamKey1
    ) {

      updates_matches[`matches.${matchKey}.away`] = {
        ...team2MatchData,
        levels: match?.away?.levels,
        sections: match?.away?.sections,
        _matchCollectionKey: match?._matchCollectionKey
      };

      affected_matches[match._itemKey] = match;

    } else if (
      match?.away?._itemKey === teamKey2 ||
      match?.away?.id === teamKey2
    ) {

      updates_matches[`matches.${matchKey}.away`] = {
        ...team1MatchData,
        levels: match?.away?.levels,
        sections: match?.away?.sections,
        _matchCollectionKey: match?._matchCollectionKey
      };

      affected_matches[match._itemKey] = match;
    }

  });

  const updates_matches_grouped = _.reduce(updates_matches, (result, matchData, updateKey) => {

    const _matchCollectionKey = matchData?._matchCollectionKey;

    if (!_matchCollectionKey) {
      return result;
    }

    if (!result[_matchCollectionKey]) {
      result[_matchCollectionKey] = {};
    }

    result[_matchCollectionKey][updateKey] = matchData;

    return result;

  }, {});

  // console.log('updates_teams', updates_teams)
  // console.log('updates_matches', updates_matches)
  // console.log('affected_matches', affected_matches)
  // console.log('updates_matches_grouped', updates_matches_grouped)
  // console.log('l', _.groupBy(updates_matches, 'levels'))

  callback({ updates_teams, updates_matches_grouped, updates_matches })


};

function highlightMatchesAndConflicts({ matches }) {

  const pairsMap = {};
  const conflictsMap = {};

  const getTeamName = team =>
    _.isObject(team) ? team?.name : team;

  // Make sure we don't retain conflicts from a previous run
  _.forEach(matches, match => {
    delete match._hasConflicts;
    delete match._conflicts;
    delete match._conflictTypes;
  });

  // --- 1) Exact Away/Home duplicates ---
  _.forEach(matches, match => {
    const { away, home } = match;

    const _home = getTeamName(home);
    const _away = getTeamName(away);

    if (!_away || !_home) return;

    const pairKey = `${_away}___${_home}`;

    if (!pairsMap[pairKey]) {
      pairsMap[pairKey] = [];
    }

    pairsMap[pairKey].push(match);
  });

  Object.entries(pairsMap).forEach(([pairKey, matchesForPair]) => {
    if (matchesForPair.length <= 1) return;

    const [away, home] = pairKey.split("___");

    const dates = _.uniq(_.map(matchesForPair, 'startDate'));

    const conflict = `Duplicate match: ${away} vs ${home} (${dates.join(', ')})`;

    _.forEach(matchesForPair, match => {
      match._hasConflicts = true;
      match._conflicts ??= [];
      match._conflictTypes ??= [];

      if (!match._conflicts.includes(conflict)) {
        match._conflicts.push(conflict);
        match._conflictTypes.push(_matchConflictTypes.duplicateMatch)
      }
    });
  });

  // --- 2) Start Date + Team conflicts ---
  _.forEach(matches, match => {
    const { startDate, away, home, approvalTypes } = match;

    if (!startDate || approvalTypes === 'Approved') return;

    const _home = getTeamName(home);
    const _away = getTeamName(away);

    if (_away) {
      const key = `${startDate}___${_away}`;
      if (!conflictsMap[key]) {
        conflictsMap[key] = [];
      }
      conflictsMap[key].push(match);
    }

    if (_home) {
      const key = `${startDate}___${_home}`;
      if (!conflictsMap[key]) {
        conflictsMap[key] = [];
      }
      conflictsMap[key].push(match);
    }
  });

  Object.entries(conflictsMap).forEach(([key, entries]) => {
    if (entries.length <= 1) return;

    const [date, team] = key.split("___");

    const conflict = `Schedule conflict: ${team} has another match on ${date}`;

    _.forEach(entries, match => {
      match._hasConflicts = true;
      match._conflicts ??= [];
      match._conflictTypes ??= [];
      match._conflictDates ??= [];

      if (!match._conflicts.includes(conflict)) {
        match._conflicts.push(conflict);
        match._conflictTypes.push(_matchConflictTypes.overlap)
        match._conflictDates.push(date)
      }
    });
  });

  return matches;
}

function compareTheMatches({ matches_gs, matches_app, teams, database_fns }) {

  const _matches_gs_conflicts = _.filter(matches_gs, m => m._hasConflicts)
  // console.log('_matches_gs_conflicts', _matches_gs_conflicts)

  const scoresNew = []
  const scoresChanged = []
  const startDateChanges = []
  const matchesNew = []
  const matchesOnlyInApp = []
  const updateTypeChanges = []

  const getTeamName = team => typeof team === 'string' ? team : team?.name

  const getMatchKey = match => {
    const home = getTeamName(match?.home)
    const away = getTeamName(match?.away)
    if (!home || !away) return null
    return `${home}|||${away}`
  }

  const appMap = _.keyBy(matches_app, getMatchKey)
  const gsMap = _.keyBy(matches_gs, getMatchKey)

  // --------------------------------------------------
  // Matches in GS
  // --------------------------------------------------

  _.forEach(matches_gs, match_gs => {
    const key = getMatchKey(match_gs)
    if (!key) return;

    const appMatch = appMap[key]
    const isCancelled = match_gs?.updateTypes?.trim()?.toLowerCase() === 'cancelled'
    const hasDuplicateConflict = _.includes(match_gs?._conflictTypes, _matchConflictTypes.duplicateMatch)

    // Exists in GS but not App
    if (!appMatch && !isCancelled && !hasDuplicateConflict) {
      matchesNew.push({
        match_gs: match_gs,
        match_app: null,
        key,
      })

      return
    }

    // ------------------------------------------------
    // Scores
    // ------------------------------------------------

    const gsAwayScore = match_gs?.awayScore
    const gsHomeScore = match_gs?.homeScore

    const hasGsScore =
      gsAwayScore != null &&
      gsAwayScore !== '' &&
      gsHomeScore != null &&
      gsHomeScore !== ''

    const appAwayScore = appMatch?.results?.score?.away
    const appHomeScore = appMatch?.results?.score?.home

    const hasAppScore =
      appAwayScore != null &&
      appHomeScore != null

    // GS has score, App doesn't
    if (hasGsScore && !hasAppScore && !hasDuplicateConflict) {
      scoresNew.push({
        match_gs: match_gs,
        match_app: appMatch,
        key,
        score: {
          home: Number(gsHomeScore),
          away: Number(gsAwayScore),
        },
      })
    }

    // Both have scores, but they differ
    else if (
      hasGsScore &&
      hasAppScore &&
      (
        Number(gsAwayScore) !== Number(appAwayScore) ||
        Number(gsHomeScore) !== Number(appHomeScore)
      )
    ) {
      scoresChanged.push({
        match_gs: match_gs,
        match_app: appMatch,
        key,
        oldScore: {
          home: Number(appHomeScore),
          away: Number(appAwayScore),
        },
        newScore: {
          home: Number(gsHomeScore),
          away: Number(gsAwayScore),
        },
      })
    }

    // ------------------------------------------------
    // Start date
    // ------------------------------------------------

    if (match_gs?.startDate && appMatch?.startDate && match_gs.startDate !== appMatch.startDate && !hasDuplicateConflict) {
      startDateChanges.push({
        match_gs: match_gs,
        match_app: appMatch,
        key,
        oldStartDate: appMatch.startDate,
        newStartDate: match_gs.startDate,
      })
    }

    // ------------------------------------------------
    // Update type
    // ------------------------------------------------

    const updateType = match_gs?.updateTypes

    const expectedFlags = {
      postponed: '_isPostponed',
      cancelled: '_isCancelled',
      exhibition: '_isExhibition',
    }

    if (updateType && expectedFlags[updateType]) {
      const flag = expectedFlags[updateType]

      if (!appMatch?.[flag]) {
        updateTypeChanges.push({
          match_gs: match_gs,
          match_app: appMatch,
          key,
          updateType,
          appFlag: flag,
        })
      }
    }
  })

  // --------------------------------------------------
  // Matches in App but not GS
  // --------------------------------------------------

  _.forEach(matches_app, appMatch => {
    const key = getMatchKey(appMatch)
    if (!key) return

    if (!gsMap[key]) {
      matchesOnlyInApp.push({
        match_gs: null,
        match_app: appMatch,
        key,
      })
    }
  })

  const { dbUpdates, groupedUpdates, matches_changed } = getMatchUpdates({
    matchesNew,
    scoresChanged,
    scoresNew,
    startDateChanges,
    teams,
    database_fns
  })

  console.log('matchesNew', matchesNew)

  return {
    // scoresNew,
    // scoresChanged,
    // startDateChanges,
    updateTypeChanges,
    // matchesNew,
    matchesOnlyInApp,
    dbUpdates,
    groupedUpdates,
    matches_changed,
  }
}

const getMatchUpdates = ({
  matchesNew,
  scoresChanged,
  scoresNew,
  startDateChanges,
  teams,
  database_fns
}) => {

  const dbUpdates = {}
  const groupedUpdates = {
    matchesNew: [],
    scoresNew: [],
    scoresChanged: [],
    startDateChanges: [],
    matches: [],
  }

  const matches_changed = {}

  const addChangedMatch = ({
    match_app,
    match,
    matchKey,
    matchStatusType,
  }) => {
    const key = matchKey || match_app?._itemKey || match_app?.id

    if (!key) return

    if (key === undefined || key === 'undefined') {
      console.log('ud match', match)
    }

    matches_changed[key] ??= {
      ...match_app,
      _matchChangeTypes: [],
    }

    matches_changed[key]._matchChangeTypes.push(matchStatusType)
    Object.assign(matches_changed[key], match)
  }

  const addDbUpdate = ({
    matchKey,
    _matchCollectionKey,
    field,
    value
  }) => {
    if (!_matchCollectionKey || !matchKey) return

    dbUpdates[_matchCollectionKey] ??= {}

    dbUpdates[_matchCollectionKey][
      `matches.${matchKey}${field ? `.${field}` : ''}`
    ] = value
  }

  // ------------------------------------------
  // New matches
  // ------------------------------------------

  _.forEach(matchesNew, ({ match_gs }) => {

    const match = getNewMatch({
      gsMatch: match_gs,
      teams,
      database_fns
    })

    if (!match) return;

    const matchKey = database_fns.get_docKey()
    const _matchCollectionKey = match._matchCollectionKey

    addDbUpdate({
      matchKey,
      _matchCollectionKey,
      value: match
    })

    groupedUpdates.matchesNew.push({
      match_gs,
      match,
      matchKey,
      _matchCollectionKey,
    })

  })

  // ------------------------------------------
  // New scores
  // ------------------------------------------

  _.forEach(scoresNew, ({ match_gs, match_app }) => {

    const matchKey = match_app._itemKey || match_app.id
    const _matchCollectionKey = match_app._matchCollectionKey

    const score = {
      home: Number(match_gs.homeScore),
      away: Number(match_gs.awayScore),
    }

    addDbUpdate({
      matchKey,
      _matchCollectionKey,
      field: 'results.score',
      value: score
    })

    groupedUpdates.scoresNew.push({
      match_gs,
      match_app,
      matchKey,
      _matchCollectionKey,
      score,
    })

    addChangedMatch({
      match_app,
      match: {
        results: {
          ...match_app?.results,
          score: {
            home: Number(match_gs.homeScore),
            away: Number(match_gs.awayScore),
          },
        },
      },
      matchStatusType: 'newMatch',
    })

  })

  // ------------------------------------------
  // Changed scores
  // ------------------------------------------

  _.forEach(scoresChanged, ({ match_gs, match_app }) => {

    const matchKey = match_app._itemKey || match_app.id
    const _matchCollectionKey = match_app._matchCollectionKey

    const oldScore = {
      home: match_app?.results?.score?.home,
      away: match_app?.results?.score?.away,
    }

    const newScore = {
      home: Number(match_gs.homeScore),
      away: Number(match_gs.awayScore),
    }

    addDbUpdate({
      matchKey,
      _matchCollectionKey,
      field: 'results.score',
      value: newScore
    })

    groupedUpdates.scoresChanged.push({
      match_gs,
      match_app,
      matchKey,
      _matchCollectionKey,
      oldScore,
      newScore,
    })

    addChangedMatch({
      match_app,
      match: {
        results: {
          ...match_app?.results,
          score: {
            home: Number(match_gs.homeScore),
            away: Number(match_gs.awayScore),
          },
        },
      },
      matchStatusType: 'scoreChanged',
    })
  })

  // ------------------------------------------
  // Start dates
  // ------------------------------------------

  console.log('startDateChanges', startDateChanges)

  _.forEach(startDateChanges, ({ match_gs, match_app }) => {

    const key_match_app = match_app._itemKey || match_app.id
    const _matchCollectionKey = match_app._matchCollectionKey

    addDbUpdate({
      matchKey: key_match_app,
      _matchCollectionKey,
      field: 'startDate',
      value: match_gs.startDate
    })

    if (match_gs.oldStartDate || match_gs._oldStartDate) {
      addDbUpdate({
        matchKey: key_match_app,
        _matchCollectionKey,
        field: '_oldStartDate',
        value: match_gs.oldStartDate || match_gs._oldStartDate
      })
    }

    groupedUpdates.startDateChanges.push({
      match_gs,
      match_app,
      matchKey: key_match_app,
      _matchCollectionKey,
      oldStartDate: match_gs.oldStartDate || match_gs._oldStartDate,
      newStartDate: match_gs.startDate,
    })


    addChangedMatch({
      match_app,
      match: {
        results: {
          ...match_app?.results,
          score: {
            home: Number(match_gs.homeScore),
            away: Number(match_gs.awayScore),
          },
        },
      },
      matchStatusType: 'startDate',
    })

  })

  return {
    dbUpdates,
    groupedUpdates,
    matches_changed
  }
}

const getNewMatch = ({ gsMatch, teams }) => {

  const getTeam = teamName => _.find(teams, team => team?.name === teamName)

  let homeTeam = getTeam(gsMatch.home)
  let awayTeam = getTeam(gsMatch.away)

  // if no home or away, return
  if (!homeTeam && !awayTeam) { return null }

  if (!awayTeam) {
    awayTeam = {
      name: gsMatch.away,
      id: gsMatch.away,
      sections: _matchLsTypes.Non,
      levels: _matchLsTypes.Non,
    }
  }

  if (!homeTeam) {
    homeTeam = {
      name: gsMatch.home,
      id: gsMatch.home,
      sections: _matchLsTypes.Non,
      levels: _matchLsTypes.Non,
    }
  }

  const bothHaveKeys = !!homeTeam._itemKey && !!awayTeam._itemKey
  const sameLevel = homeTeam.levels === awayTeam.levels
  const sameSection = homeTeam.sections === awayTeam.sections

  let matchLevels = _matchLsTypes.Non
  let _matchCollectionKey = _matchLsTypes.Non

  if (sameLevel && sameSection) {
    matchLevels = homeTeam.levels
    _matchCollectionKey = homeTeam.levels
  } else if (!bothHaveKeys) {
    matchLevels = _matchLsTypes.nonDistrict
    _matchCollectionKey = _matchLsTypes.nonDistrict
  } else if (sameLevel) {
    matchLevels = homeTeam.levels
  }

  const levelMismatch = matchLevels !== gsMatch?.levels

  const match = {
    home: {
      name: homeTeam.name,
      levels: homeTeam.levels,
      sections: homeTeam.sections,
      id: homeTeam.id || homeTeam.key || homeTeam._itemKey,
    },

    away: {
      name: awayTeam.name,
      levels: awayTeam.levels,
      sections: awayTeam.sections,
      id: awayTeam.id || awayTeam.key || awayTeam._itemKey,
    },
    levels: matchLevels,
    sections: gsMatch.sections,
    startDate: gsMatch.startDate,
    startTime: '7:00 PM',
    _matchCollectionKey,
    // _levelMismatch: levelMismatch
  }

  match.teams = [match.away.id, match.home.id]

  // Add results if GS has a score
  if (
    gsMatch?.homeScore != null &&
    gsMatch?.awayScore != null &&
    gsMatch.homeScore !== '' &&
    gsMatch.awayScore !== ''
  ) {
    match.results = {
      score: {
        home: Number(gsMatch.homeScore),
        away: Number(gsMatch.awayScore),
      },
    }
  }

  return match
}

const analyzeTheMatches = ({ matches_app = [], matches_gs = [], teams = {} }) => {

  if (_.isEmpty(matches_app) || _.isEmpty(matches_gs)) return {}

  const compareValues = (a, b) => _.isEqual(a, b);

  console.log('matches_app', matches_app)
  const xx = groupMatchesByTeam(matches_app)
  const yy = findSameTeamMatches(matches_app)
  console.log('xx', xx)
  console.log('yy', yy)
  // ------------------------------------------------------------
  // Index matches
  // ------------------------------------------------------------

  const matchKeys_app = _.keyBy(
    _.filter(matches_app, m => getMatchKey(m)),
    getMatchKey
  );

  const matchKeys_gs = _.keyBy(
    _.filter(matches_gs, m => getMatchKey(m)),
    getMatchKey
  );

  const duplicates_app = [];
  const duplicates_gs = [];

  // group the matche by the match keys
  const appKeyGroups = _.groupBy(
    _.filter(matches_app, m => getMatchKey(m)),
    getMatchKey
  );

  const googleKeyGroups = _.groupBy(
    _.filter(matches_gs, m => getMatchKey(m)),
    getMatchKey
  );

  // see if any of the match keys have more that one.
  _.forEach(appKeyGroups, (matches, key) => {
    if (matches.length > 1) {
      _.forEach(matches, match => {
        // console.log('DUPS App', matches)
        addMatchStatusType(match, _matchConflictTypes.duplicateMatch);
        duplicates_app.push(match);
      });
    }
  });

  _.forEach(googleKeyGroups, (matches, key) => {
    if (matches.length > 1) {
      // console.log('DUPS match_gs', matches)
      _.forEach(matches, match => {
        addMatchStatusType(match, _matchConflictTypes.duplicateMatch);
        duplicates_gs.push(match);
      });
    }
  });


  // ------------------------------------------------------------
  // Results comparison
  const addResultUpdates = (match_app, match_gs) => {

    const results_gs = _.cloneDeep(match_app?.results || {});

    let changed = false;

    const resultPaths = [
      {
        key: 'home',
        path_gs: 'homeScore',
      },
      {
        key: 'away',
        path_gs: 'awayScore',
      },
    ];

    _.forEach(resultPaths, ({ key, path_gs }) => {

      const value_app = match_app?.results?.score?.[key];

      const value_gs = match_gs?.[path_gs] === '' ||
        match_gs?.[path_gs] == null
        ? undefined
        : Number(match_gs[path_gs]);

      if (compareValues(value_app, value_gs)) {
        return;
      }

      changed = true;

      _.set(results_gs, `score.${key}`, value_gs);
    });

    if (!changed) {
      return;
    }

    addUpdate(
      match_app,
      matchTargetTypes.match_app,
      'results',
      results_gs
    );

    addUpdate(
      match_gs,
      matchTargetTypes.match_gs,
      'results',
      match_app?.results
    );

    addMatchStatusType(match_app, _matchConflictTypes.resultsChanged);
    addMatchStatusType(match_gs, _matchConflictTypes.resultsChanged);
  };

  const addResultUpdatesXX = (match_app, match_gs) => {

    const resultPaths = [
      {
        key: 'home',
        path_app: 'results.score.home',
        path_gs: 'homeScore',
      },
      {
        key: 'away',
        path_app: 'results.score.away',
        path_gs: 'awayScore',
      },
    ];

    let changed = false;

    _.forEach(resultPaths, ({ key, path_app, path_gs }) => {

      const value_app = match_app?.results?.score?.[key];

      const value_gs = match_gs?.[path_gs] === '' ||
        match_gs?.[path_gs] == null
        ? undefined
        : Number(match_gs[path_gs]);


      if (compareValues(value_app, value_gs)) {
        return;
      }

      changed = true;

      if (value_gs !== undefined) {
        addUpdate(match_app, matchTargetTypes.match_app, path_app, value_gs);
      }

      if (value_app !== undefined) {
        addUpdate(match_gs, matchTargetTypes.match_gs, path_gs, String(value_app));
      }
    });

    if (changed) {
      addMatchStatusType(match_app, _matchConflictTypes.resultsChanged);
      addMatchStatusType(match_gs, _matchConflictTypes.resultsChanged);
    }
  };

  // ------------------------------------------------------------
  // Process GS → App / App → GS
  // ------------------------------------------------------------

  const analyzedMatches = [];

  const allKeys = _.uniq([
    ...Object.keys(matchKeys_app),
    ...Object.keys(matchKeys_gs)
  ]);

  _.forEach(allKeys, key => {

    const match_app = matchKeys_app[key];
    const match_gs = matchKeys_gs[key];

    // ----------------------------------------------------------
    // Exists in both
    // ----------------------------------------------------------

    if (match_app && match_gs) {

      const _match_app = _.cloneDeep(match_app);

      _match_app._matchUpdateTypes = [];

      // --------------------------------------------------------
      // Validate match section / level against teams
      // --------------------------------------------------------

      // const expected = getExpectedMatchValues(teams, match_app);

      // if (expected.validated) {

      //   if (match_app.sections !== expected.expectedSections) {
      //     addMatchStatusType(_match_app, 'invalidMatchSection');
      //   }

      //   if (match_app.levels !== expected.expectedLevels) {
      //     addMatchStatusType(_match_app, 'invalidMatchLevel');
      //   }
      // }

      // --------------------------------------------------------
      // Start date
      // --------------------------------------------------------

      if (match_app.startDate !== match_gs.startDate) {

        // console.log('DATE CHANGED 1', match_gs)
        addMatchStatusType(_match_app, _matchConflictTypes.dateChanged);

        addUpdate(_match_app, matchTargetTypes.match_app, 'startDate', match_gs.startDate);
        addUpdate(match_gs, matchTargetTypes.match_gs, 'startDate', match_app.startDate);
      }

      // --------------------------------------------------------
      // Sections
      // --------------------------------------------------------

      // if (applyLs && match_app.sections !== match_gs.sections) {

      //   addMatchStatusType(_match_app, 'updatedSections');

      //   addUpdate(
      //     _match_app,
      //     matchTargetTypes.match_app,
      //     'sections',
      //     match_gs.sections
      //   );
      // }

      // --------------------------------------------------------
      // Levels
      // --------------------------------------------------------

      // if (applyLs && match_app.levels !== match_gs.levels) {

      //   addMatchStatusType(_match_app, 'updatedLevels');

      //   addUpdate(
      //     _match_app,
      //     matchTargetTypes.match_app,
      //     'levels',
      //     match_gs.levels
      //   );
      // }

      // --------------------------------------------------------
      // GS update types
      // --------------------------------------------------------

      const updateTypes = _.castArray(
        match_gs.updateTypes
      ).filter(Boolean);

      const approvalTypes = _.castArray(
        match_gs.approvalTypes
      ).filter(Boolean);

      if (updateTypes.includes('canceled')) {

        if (!match_app._isDeleted) {

          addMatchStatusType(_match_app, _matchConflictTypes.cancelled);
          addUpdate(_match_app, matchTargetTypes.match_app, '_isDeleted', true);
        }
      }

      if (
        updateTypes.includes('exhibition') &&
        !match_app._isExhibition
      ) {

        addMatchStatusType(_match_app, _matchConflictTypes.exhibition);
        addUpdate(_match_app, matchTargetTypes.match_app, '_isExhibition', true);
      }

      if (
        updateTypes.includes('postponed') &&
        !match_app._isPostponed
      ) {

        addMatchStatusType(_match_app, _matchConflictTypes.postponed);

        addUpdate(_match_app, matchTargetTypes.match_app, '_isPostponed', true);
      }

      if (updateTypes.includes('approved')) {
        addMatchStatusType(_match_app, 'approved');
      }

      // --------------------------------------------------------
      // Results
      // --------------------------------------------------------

      addResultUpdates(_match_app, match_gs);

      analyzedMatches.push(_match_app);

      return;
    }


    // ----------------------------------------------------------
    // GS match not found by current key
    // ----------------------------------------------------------

    if (match_gs && !match_app) {

      const _match_gs = _.cloneDeep(match_gs);

      _match_gs._matchUpdateTypes = [];

      // --------------------------------------------------------
      // First check Old Start Date.
      //
      // This catches a postponed/rescheduled match.
      // --------------------------------------------------------

      const oldKey = getOldMatchKey(match_gs);

      const match_app_old = oldKey ? matchKeys_app[oldKey] : null;

      if (match_app_old) {

        const oldExists = match_app_old._oldStartDate === match_gs.startDate

        const oldKey = getOldMatchKey(match_gs);

        _match_gs._matchCollectionKey = match_app_old._matchCollectionKey
        _match_gs._itemKey = match_app_old._itemKey

        console.group('OLD !!!', match_app_old._itemKey, oldExists)
        console.log('match_gs.startDate', match_gs.startDate)
        console.log('match_gs.oldStartDate', match_gs.oldStartDate)
        console.log('match_app_old.startDate', match_app_old.startDate)
        console.log('match_app_old._oldStartDate', match_app_old._oldStartDate)
        console.log('match_app_old', match_app_old)
        console.groupEnd()

        addMatchStatusType(_match_gs, _matchConflictTypes.dateChanged);
        addUpdate(_match_gs, matchTargetTypes.match_app, 'startDate', match_gs.startDate);
        // The old match_app match is the match that needs moving.
        _match_gs._sourceMatchKey = oldKey;
        analyzedMatches.push(_match_gs);
        return;
      }


      // --------------------------------------------------------
      // Truly new GS match
      // --------------------------------------------------------

      addMatchStatusType(_match_gs, _matchConflictTypes.matchIsNew);

      // This is where the existing Firebase function
      // that creates the match_app match would eventually be called.
      //
      // callFirebaseFunction()

      analyzedMatches.push(_match_gs);

      return;
    }


    // ----------------------------------------------------------
    // App match not found in GS
    // ----------------------------------------------------------

    if (match_app && !match_gs) {

      const _match_app = _.cloneDeep(match_app);

      _match_app._matchUpdateTypes = [];

      addMatchStatusType(_match_app, _matchConflictTypes.matchIsMissing);

      // Existing match_app match/result needs to be represented
      // in GS.
      //
      // The exact GS update fields can be extracted later
      // from _updates_gs.

      addUpdate(_match_app, matchTargetTypes.match_gs, 'home', getTeamName(match_app.home));
      addUpdate(_match_app, matchTargetTypes.match_gs, 'away', getTeamName(match_app.away));

      // addUpdate(
      //   _match_app,
      //   'google',
      //   'sections',
      //   match_app.sections
      // );

      // addUpdate(
      //   _match_app,
      //   'google',
      //   'levels',
      //   match_app.levels
      // );

      addUpdate(_match_app, matchTargetTypes.match_gs, 'startDate', match_app.startDate);

      if (match_app.results) {
        const flattenedResults = {};

        const flatten = (obj, prefix = '', output = {}) => {
          _.forEach(obj, (value, key) => {
            const path = prefix
              ? `${prefix}.${key}`
              : key;

            if (_.isObject(value) && !_.isArray(value)) {
              flatten(value, path, output);
            } else {
              output[path] = value;
            }
          });

          return output;
        };

        flatten(match_app.results, 'results', flattenedResults);

        _.forEach(
          flattenedResults,
          (value, path) => {
            addUpdate(_match_app, matchTargetTypes.match_gs, path, value);
          }
        );
      }

      analyzedMatches.push(_match_app);
    }
  });


  // ------------------------------------------------------------
  // Same-team / same-day conflicts
  // ------------------------------------------------------------



  // Run conflict detection independently on both sources.
  checkConflicts(_.cloneDeep(matches_app));
  checkConflicts(_.cloneDeep(matches_gs));


  // ------------------------------------------------------------
  // GS deletable
  // ------------------------------------------------------------

  _.forEach(matches_gs, googleMatch => {

    const key = getMatchKey(googleMatch);

    if (!key || matchKeys_app[key]) return;

    const updateTypes = _.castArray(
      googleMatch.updateTypes
    ).filter(Boolean);

    if (updateTypes.includes('Canceled')) {

      const result = analyzedMatches.find(m => getMatchKey(m) === key);

      if (result) {
        addMatchStatusType(result, 'googleDeletable');
      }
    }
  });


  // ------------------------------------------------------------
  // Return
  // ------------------------------------------------------------

  const _updates_app = _.filter(
    analyzedMatches,
    match => !_.isEmpty(match._updates_app)
  )

  return {
    matches: analyzedMatches,
    updates_app: _updates_app,
    updates_gs: _.filter(
      analyzedMatches,
      match => !_.isEmpty(match._updates_gs)
    ),
    issues: {
      duplicates_app,
      duplicates_gs
    }
  };

};


// ------------------------------------------------------------
// Helpers
// ------------------------------------------------------------

const applyLs = false

const getTeamName = team => _.isObject(team) ? team?.name : team;

const getMatchKey = (match) => {
  const home = getTeamName(match?.home);
  const away = getTeamName(match?.away);
  if (!match?.startDate) return;
  if (!home || !away) {
    console.log('home', away, home)
    return null
  };
  return `${away}|${home}|${match.startDate}`;
};

const getOldMatchKey = match => {
  if (!match?.oldStartDate) return null;
  const home = getTeamName(match?.home);
  const away = getTeamName(match?.away);
  if (!home || !away) return null;
  return `${away}|${home}|${match.oldStartDate}`;
};

const getTeam = (teams, team) => {
  const teamName = getTeamName(team);
  if (!teamName) return null;
  // Adjust this if your teams object is keyed differently.
  return teams?.[teamName] || null;
};

const getExpectedMatchValues = (teams, match) => {
  const homeTeam = getTeam(teams, match?.home);
  const awayTeam = getTeam(teams, match?.away);
  // Cannot validate a non-district match.
  if (!homeTeam || !awayTeam) {
    return {
      validated: false,
      expectedSections: null,
      expectedLevels: null
    };
  }

  const expectedSections =
    homeTeam.levels === awayTeam.levels &&
      homeTeam.sections === awayTeam.sections
      ? homeTeam.sections
      : 'Non';

  const expectedLevels =
    homeTeam.levels === awayTeam.levels &&
      homeTeam.sections === awayTeam.sections
      ? homeTeam.levels
      : 'Non';

  return {
    validated: true,
    expectedSections,
    expectedLevels
  };
};

const addMatchStatusType = (match, status) => {
  if (!match._matchUpdateTypes) {
    match._matchUpdateTypes = [];
  }

  if (!match._matchUpdateTypes.includes(status)) {
    match._matchUpdateTypes.push(status);
  }
};

const addUpdate = (match, direction, path, value) => {
  const key = direction === matchTargetTypes.match_app
    ? '_updates_app'
    : '_updates_gs';

  if (!match[key]) {
    match[key] = {};
  }

  match[key][path] = value;
};

const checkConflicts = matches => {

  const teamDates = {};
  const teamMatches = {};

  _.forEach(matches, match => {

    const date = match?.startDate;
    if (!date) return;

    const home = getTeamName(match.home);
    const away = getTeamName(match.away);

    _.forEach([home, away], team => {

      if (!team) return;

      if (!teamDates[team]) {
        teamDates[team] = {};
      }

      if (!teamMatches[team]) {
        teamMatches[team] = {};
      }

      if (!teamDates[team][date]) {
        teamDates[team][date] = [];
      }

      teamDates[team][date].push(match);

      if (!teamMatches[team][date]) {
        teamMatches[team][date] = [];
      }

      teamMatches[team][date].push(match);
    });
  });


  _.forEach(teamMatches, dates => {

    _.forEach(dates, matchesOnDate => {

      if (matchesOnDate.length < 2) return;

      _.forEach(matchesOnDate, match => {

        const updateTypes = _.castArray(
          match.updateTypes
        ).filter(Boolean);

        // Approved explicitly allows the same team
        // to play another opponent on the same day.
        if (updateTypes.includes('Approved')) {
          addMatchStatusType(match, 'approved');
          return;
        }

        const matchKey = getMatchKey(match);

        const conflicts = _.filter(
          matchesOnDate,
          other => getMatchKey(other) !== matchKey
        );

        if (conflicts.length) {
          addMatchStatusType(match, 'scheduleConflict');

          match._conflicts = _.map(
            conflicts,
            getMatchKey
          );
        }
      });
    });
  });


  // ----------------------------------------------------------
  // Also identify teams playing on other dates
  // ----------------------------------------------------------

  const allTeamDates = {};

  _.forEach(matches, match => {

    const date = match?.startDate;
    if (!date) return;

    _.forEach([
      getTeamName(match.home),
      getTeamName(match.away)
    ], team => {

      if (!team) return;

      if (!allTeamDates[team]) {
        allTeamDates[team] = new Set();
      }

      allTeamDates[team].add(date);
    });
  });

  _.forEach(matches, match => {

    const date = match?.startDate;

    const otherDates = [];

    _.forEach([
      getTeamName(match.home),
      getTeamName(match.away)
    ], team => {

      _.forEach(
        [...(allTeamDates[team] || [])],
        otherDate => {
          if (otherDate !== date) {
            otherDates.push(otherDate);
          }
        }
      );
    });

    if (otherDates.length) {
      match._startDates = _.uniq(otherDates);
    }
  });
};

const groupMatchesByTeam = matches => _.mapValues(
  _.groupBy(
    _.flatMap(matches, match => [
      { team: match.home?.name, match },
      { team: match.away?.name, match }
    ]),
    'team'
  ),
  items => _.map(items, 'match')
)

const findSameTeamMatches = matches =>
  _.filter(matches, match =>
    match.home?.name &&
    match.away?.name &&
    match.home.name === match.away.name
  )

const buildMatchTeamKeyUpdates = ({ matches }) => {
  const updates = _.map(matches, match => {
    const update = {}

    _.forEach(['home', 'away'], side => {
      const team = match[side]
      const key = team?.id ?? team?._itemKey

      if (key) {
        update[`matches.${match._itemKey}.${side}.id`] = key
        update[`matches.${match._itemKey}.${side}._itemKey`] = key
      }
    })

    return {
      _matchCollectionKey: match._matchCollectionKey,
      update
    }
  })

  return _.mapValues(
    _.groupBy(updates, '_matchCollectionKey'),
    items => _.assign({}, ..._.map(items, 'update'))
  )
}

const buildMatchTopLevelDeletes = ({ matches }) => {
  const updates = _.map(matches, match => ({
    _matchCollectionKey: match._matchCollectionKey,
    update: {
      [match._itemKey]: deleteField()
    }
  }))

  return _.mapValues(
    _.groupBy(updates, '_matchCollectionKey'),
    items => _.assign({}, ..._.map(items, 'update'))
  )
}

const buildMatchRemoves = ({ matches }) => {
  const updates = _.map(matches, match => {
    const update = {}
    update[`matches.${match._itemKey}`] = deleteField()
    return {
      _matchCollectionKey: match._matchCollectionKey,
      update
    }
  })

  return _.mapValues(
    _.groupBy(updates, '_matchCollectionKey'),
    items => _.assign({}, ..._.map(items, 'update'))
  )
}